import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
    selector: 'entity-boolean-icon-renderer',
    template: `
        <span *ngIf="value != undefined" class="icon-center" fxFill fxLayout="row" fxLayoutAlign="center center">
            <p-icon [name]="value | booleanIcon"></p-icon>
        </span>
    `,
    styleUrls: ['./boolean-icon-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BooleanIconRendererComponent implements ICellRendererAngularComp {
    value: any;

    constructor(private cd: ChangeDetectorRef) {}

    agInit(params: ICellRendererParams): void {
        this.value = params.getValue?.();
    }

    refresh(params: ICellRendererParams): boolean {
        this.value = params.getValue?.();
        this.cd.detectChanges();
        return true;
    }
}
